export interface IIcePhenomenaCodeFormatter {
  (icePhenomenaCode:number):string;
}

export interface IIcePhenomenaIntensityFormatter {
  (icePhenomenaIntensity:number):string;
}

export const icePhenomenaCodeFormatterFactory =
    ($translate:ng.translate.ITranslateService):IIcePhenomenaCodeFormatter => {
      return (icePhenomenaCode:number) => {
        return $translate.instant(`ICE_PHENOMENA_${icePhenomenaCode}`);
      }
    };
icePhenomenaCodeFormatterFactory.$inject = ['$translate'];

export const icePhenomenaIntensityFormatterFactory =
    ():IIcePhenomenaIntensityFormatter => {
      return (icePhenomenaIntensity) => {
        if (icePhenomenaIntensity && typeof icePhenomenaIntensity === 'number') {
          return `${icePhenomenaIntensity * 10}%`;
        }
        return '---';
      }
    };


export namespace IcePhenomena {
  const VALID_CODE_RANGES = [[11,26], [30,54], [63,77]];
  const CODES_WITH_INTENSITY = [12, 13, 14, 16, 19, 39, 48, 49, 50, 64];

  export function verifyIcePhenomena(code:number, intensity:number):boolean {
    const filteredRange = VALID_CODE_RANGES.filter(([rangeStart, rangeEnd]) => {
      return rangeStart <= code && code <= rangeEnd;
    });
    if (filteredRange.length == 0) {
      return false;
    }
    if (CODES_WITH_INTENSITY.indexOf(code) != -1) {
      if (intensity < 1 || intensity > 10) {
        return false;
      }
    } else if (code != intensity) {
      return false;
    }
    return true;
  }
}





/** WEBPACK FOOTER **
 ** ./app/operational/input/kn15-telegram/ice-phenomena.ts
 **/